// extracted by mini-css-extract-plugin
export default {"ReviewSection":"styles_ReviewSection__XcD0z","title":"styles_title__jZcID","contentBox":"styles_contentBox__RgNoP"};